import makeThunktankAction from '@tmap/mmm-core/redux/thunktank/makeThunktankAction';
import { getClient } from '../lib/apiClient';

export const getGeoname = makeThunktankAction(
  async (geonameId) => {
    const res = await getClient(process.env.NEXT_PUBLIC_API_DOMAIN).get(
      `/api/v1/geonames/${geonameId}`,
    );
    const [geoname] = res.data;
    return { geoname };
  },
);

export const getGeonameAutocomplete = makeThunktankAction(
  async (stub) => {
    const res = await getClient(process.env.NEXT_PUBLIC_API_DOMAIN).get(
      `/api/v1/geonames/autocomplete/${stub}`,
    );
    const autocomplete = res.data;
    return { autocomplete };
  },
);
